import { ConfigurationProfilesBaseDataProvider } from './ConfigurationProfilesBaseDataProvider';
import { ConfigurationProfilesWebComponentSchema } from '../types';

export class ConfigurationProfilesGzDataProvider extends ConfigurationProfilesBaseDataProvider {
  async getDataForView(): Promise<ConfigurationProfilesWebComponentSchema> {
    return {} as unknown as ConfigurationProfilesWebComponentSchema;
  }
}
